import * as React from 'react';
import Box from '@mui/material/Box';

import { Button } from 'components/Button';
import { colors } from 'theme/colors';

import LockIcon from './LockIcon';

import { HeaderContainer, Header, LockedText, MainContainer, KeyFeatures, Info } from './styles';

const LockedPage: React.FunctionComponent<{ pageName: string; infoTitle: string; infoText: string; image: string }> = ({
  pageName,
  infoTitle,
  infoText,
  image,
}) => (
  <Box sx={{ padding: '20px', background: colors.grey[100], margin: 0, height: '100%' }}>
    <HeaderContainer>
      <Header>{pageName}</Header>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <LockIcon />
        <LockedText>Locked</LockedText>
      </Box>
    </HeaderContainer>

    <MainContainer>
      <img src={image} alt="key-features" style={{ maxHeight: '256px' }} />

      <KeyFeatures>{infoTitle}</KeyFeatures>
      <Info>{infoText}</Info>

      <Button
        style={{ padding: '6px 16px' }}
        onClick={() => {
          window.open('https://www.vatix.com/contact-us/', '_blank');
        }}
        variant="contained"
        color="primary"
      >
        <p style={{ margin: 0, textTransform: 'uppercase' }}>Talk to sales</p>
      </Button>
    </MainContainer>
  </Box>
);

export default LockedPage;
